/* eslint-disable */
import axios from "axios";
import config from "./config";
import router from "@/router";
import { Message } from "element-ui";
import { localStorageGet } from "@/utils/localStorageGet";
import store from "@/store";
var baseURL = config.baseURL;
if (config.mock) {
  baseURL = "";
}
const service = axios.create({
  baseURL: baseURL,
  headers: config.headers,
  // withCredentials:true,
  timeout: config.timeout
});
// request拦截器
service.interceptors.request.use(
  options => {
    // console.log(options.status,1,options);
    if (
      window.location.href.slice(window.location.href.length - 5) == "login"
    ) {
      return options;
    }
    let token = localStorageGet("token");
    // let tissId = localStorage.loginTissueId
    // if (window.location.href.indexOf('/login') != -1 && window.location.href.indexOf('/login?') != -1) {
    //   console.log(window.location.href,window.location.search)
    // }
    // if (!tissId) {
    //   Message({ message: "组织超时,请重新登录", type: "error" });
    //   localStorage.clear()
    //   localStorage.removeItem('token')
    //   localStorage.removeItem('userButtonList')//用户菜单按钮权限
    //   localStorage.removeItem("roleId");
    //   store.commit("RouterLoad", false);
    //   store.commit("updateTabList", []);
    //   store.commit("updateActiveTab", "");
    //   router.push("/login");
    // }
    if (token) {
      options.headers.Token = token;
      // 组织ID优先级：
      // 1) 调用方显式传入 headers['X-Tissue-Id']
      // 2) localStorage.loginTissueId
      // 注意：不要从 data/params 的 tissueId 推导/覆盖请求头，避免出现
      // “传参查某园区，但请求头却变成该园区上下文”的混淆问题。
      const pickFirstId = (raw) => {
        if (raw === undefined || raw === null) return "";
        const s = String(raw).trim();
        if (!s) return "";
        // tissueIds 可能是逗号字符串，header 只能放单值，取第一个非空
        const first = s.split(",").map(v => (v || "").trim()).find(v => v);
        return first ? String(first) : "";
      };
      const headerPreset = options && options.headers ? options.headers["X-Tissue-Id"] : undefined;
      const fromStorage = pickFirstId(localStorage.loginTissueId);
      const tissueIdForHeader = pickFirstId(headerPreset) || fromStorage;

      if (tissueIdForHeader) {
        options.headers["X-Tissue-Id"] = tissueIdForHeader;
      } else {
        // 没有可用组织ID时不强行下发，避免出现 "undefined"/空串污染后端上下文
        try { delete options.headers["X-Tissue-Id"]; } catch (e) {}
      }
      // options.headers.Client = localStorageGet("client");
    } else {
      // 重定向到登录页面
      Message({ message: "登录超时,请重新登录", type: "error" });
      localStorage.removeItem("roleId");
      store.commit("RouterLoad", false);
      store.commit("updateTabList", []);
      store.commit("updateActiveTab", "");
      router.push("/login");
    }
    return options;
  },
  error => {
    console.log(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  res => {
    if (res.status == 401 || res.data.code == 30 || res.data.code == 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("roleId");
      router.push("/login");
    }
    if (res.data.code === 2) {
      if (store.state.app.online) {
        Message({ message: res.data.msg, type: "error" });
        localStorage.removeItem("token");
        localStorage.removeItem("roleId");
        store.commit("RouterLoad", false);
        store.commit("online", false);
        store.commit("updateTabList", []);
        store.commit("updateActiveTab", "");
        router.push("/login");
      }
    } else if (res.data.msg === "运行时异常") {
      Message({ message: res.data.msg, type: "error" });
    } else {
      let data = res.data;
      return data;
    }
  },
  // eslint-disable-next-line indent
  err => {
    // 服务端 5xx（如 500）通常不代表登录失效：避免误清 token 并跳转登录页
    const status = err && err.response ? err.response.status : null;
    const safeStatus = status === null || status === undefined ? null : Number(status);
    // 强制覆盖：502/505 只提示不跳登录
    if (safeStatus !== null && (safeStatus === 502 || safeStatus === 505 || safeStatus >= 500)) {
      Message({ message: `服务器错误(${safeStatus})，请稍后重试`, type: "error" });
      return Promise.reject(err);
    }
    // 兜底：如果某些情况下 status 读不到，但错误信息包含 502/505，也不跳登录
    const errStr = err && err.message ? String(err.message) : JSON.stringify(err || {});
    if (errStr.indexOf(' 502') !== -1 || errStr.indexOf('502') !== -1 || errStr.indexOf(' 505') !== -1 || errStr.indexOf('505') !== -1) {
      Message({ message: "服务器错误，请稍后重试", type: "error" });
      return Promise.reject(err);
    }
    // 413：nginx/网关限制请求体大小，与登录态无关
    if (safeStatus === 413) {
      Message({ message: "上传文件过大，请压缩后重试", type: "error" });
      return Promise.reject(err);
    }
    // 401：未授权，跳转登录
    if (safeStatus === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("roleId");
      router.push("/login");
      return Promise.reject(err);
    }
    // 其它 4xx 客户端错误：仅提示，不跳转登录
    if (safeStatus !== null && safeStatus >= 400 && safeStatus < 500) {
      Message({ message: `请求失败(${safeStatus})，请稍后重试`, type: "error" });
      return Promise.reject(err);
    }

    // 检查是否是用户主动取消的请求
    if (axios.isCancel && axios.isCancel(err)) {
      // 用户主动取消请求，不跳转登录页面
      return Promise.reject(err);
    }
    
    if (err.code === "ECONNABORTED" && err.message.indexOf("timeout") !== -1) {
      Message({ message: "服务器超时,请取消后重新发起", type: "error" });
    } else if (JSON.stringify(err).indexOf("404") > -1) {
      Message({ message: "请求出错!", type: "error" });
    } else if (JSON.stringify(err).indexOf("Network") > -1) {
      Message({
        message: "未能连接服务器请检查网络或其他原因!",
        type: "error"
      });
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("roleId");
      router.push("/login");
    }
    return Promise.reject(err); // 返回接口返回的错误信息
  }
);
export default service;
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/api/axios.js